import { useOffline } from "../lib/offline-context.js";
import { usePendingPhotosCount } from "../lib/use-pending-photos-count.js";

const VARIANTS = {
  online: {
    label: "● en ligne",
    className: "bg-emerald-100 text-emerald-900",
  },
  offline: {
    label: "● hors-ligne",
    className: "bg-amber-100 text-amber-900",
  },
  "server-unavailable": {
    label: "● serveur injoignable",
    className: "bg-orange-100 text-orange-900",
  },
} as const;

export function SyncBanner() {
  const { connectionState, queueLength, lastSync, flush } = useOffline();
  const photos = usePendingPhotosCount();
  const variant = VARIANTS[connectionState];
  const canSync = connectionState === "online";

  return (
    <div
      className={`text-xs px-3 py-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 ${variant.className}`}
    >
      <span className="font-medium">{variant.label}</span>
      {queueLength > 0 && (
        <span>
          {queueLength} mutation{queueLength > 1 ? "s" : ""} en attente
        </span>
      )}
      {photos > 0 && (
        <span>
          {photos} photo{photos > 1 ? "s" : ""} à envoyer
        </span>
      )}
      {lastSync && (
        <span className="text-muted-foreground">
          dernière sync : {new Date(lastSync).toLocaleTimeString("fr-FR")}
        </span>
      )}
      <button
        onClick={() => flush().catch(() => undefined)}
        className="ml-auto underline disabled:opacity-50"
        disabled={!canSync}
      >
        Synchroniser
      </button>
    </div>
  );
}
